<template>
  <div class="home">
    <div class="kv">
      <div class="block">
        <div class="banner banner1">
          <!-- <el-carousel
            :interval="5000"
            trigger="click"
            :arrow="arrow"
            class="el-carousel"
          >
            <el-carousel-item
              v-for="(item, index) in bannerList"
              :key="index"
              :class="item.calssName"
            > -->
          <!-- <dyna-img class="kv-title" :src="bannerList[0].titleSrc"></dyna-img> -->
          <!-- <router-link
                :to="
                  $i18n.locale === 'cn'
                    ? bannerUrl[index]
                    : bannerUrl[index] + '/' + $i18n.locale
                "
              > -->
          <dyna-img
            style="width: 100%; display:block;"
            :src="bannerList[0].imgSrc"
          >
          </dyna-img>
          <!-- </router-link> -->
          <!-- </el-carousel-item>
          </el-carousel> -->
        </div>
      </div>
    </div>
    <div class="comment">
      <p class="title">{{ title }}</p>
      <el-carousel trigger="click" :arrow="arrow" :autoplay="false">
        <el-carousel-item v-for="(item, index) in commentList" :key="index">
          <div class="comment-box">
            <!-- <a :href="item.link" target="_blank"> -->
            <div class="comment-img">
              <!-- v-lazy-container="{ selector: 'img' }" -->
              <div class="img">
                <!--  -->
                <img :src="item.img" alt="" />
                <!-- <img :data-src="item.img" alt="" /> -->
              </div>
            </div>
            <!-- </a> -->
            <!-- <a :href="item.link" target="_blank"> -->
            <div class="comment-intro">
              <p class="name">{{ item.name }}</p>
              <p class="intro">{{ item.intro }}</p>
            </div>
            <!-- </a> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="link-block">
      <div v-for="(item, ind) in linkList" :key="ind" :class="item.calssName">
        <ul>
          <li v-for="(child, index) in item.children" :key="index">
              <div v-if="item.calssName === 'link-box-video'" >
                <div class="img-box">
                   <div class="mask"></div>
                <dyna-img :src="child.videoPoster"></dyna-img>
                </div>
                <div class="title" @click='imgEvent(child)'> <span>{{ child.title }}</span><p class="text"><span>Watch film</span><img :src="logo3" alt=""></p> </div>
             </div>
             <div v-else>
                 <div class="img-box">
                   <div class="mask"></div>
                    <dyna-img :src="child.videoPoster"></dyna-img>
                </div>
                <a :href="child.link">
                  <div class="title"><span>{{ child.title }}</span><p class="text"><span>Learn more</span><img :src="logo3" alt=""></p></div>
                </a>
             </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="logo-box">
        <!-- <img src="" alt="">
        <img src="" alt=""> -->
        <div class="content">
            <div>Partner</div>
            <dyna-img class="img-left" :src="logo1" />
        </div>
        <div class="content">
            <div>Supported by</div>
            <dyna-img :src="logo2" />
        </div>
        
        <!-- <dyna-img :src="logo2" /> -->
    </div>
    <pop-video
      :config="videoConfig"
      :visible="openVideo"
      @closeVideo="closeVideo"
    ></pop-video>
  </div>
</template>

<script>
import DynaImg from "@/components/dynaImg";
import PopVideo from "@/components/popvideo";

export default {
  name: "Home",
  components: {
    DynaImg,
    PopVideo,
  },
  data() {
    return {
      openVideo: false,
      videoConfig: null,
      arrow: "hover",
      title: "From our media friends:",
      logo1: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/bottom_nav/bottom-national-test.svg',
      logo2: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/bottom_nav/bottom-zeiss-test.svg',
      logo3: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/watchFilm.svg',
      bannerList: [
        {
          calssName: "banner1",
          imgSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/en-home-kv-img1-pc.jpg",
          titleSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/en-home-kv-title1-pc.png",
          // link: store.state.lang === 'cn' ? '/news/launch' : '/news/launch' + store.state.lang
        },
        {
          calssName: "arena",
          imgSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-img6-pc.jpg",
          titleSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-title6-pc.png",
          // link: store.state.lang === 'cn' ? '/news/martinparr' : '/news/martinparr' + store.state.lang
        },
        {
          calssName: "bannerAbout",
          imgSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-about-img-pc.jpg",
          titleSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-about-title-pc.png",
          // link: store.state.lang === 'cn' ? '/about' : '/about' + store.state.lang
        },
        {
          calssName: "banner2",
          imgSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-img2-pc.jpg",
          titleSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-title2-pc.png",
          // link: store.state.lang === 'cn' ? '/news/martinparr' : '/news/martinparr' + store.state.lang
        },
        {
          calssName: "banner3",
          imgSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-img3-pc.jpg",
          titleSrc:
            "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-title3-pc.png",
          // link: store.state.lang === 'cn' ? '/news/xiaoquan' : '/news/xiaoquan' + store.state.lang
        },
        // {
        //   calssName: 'banner4',
        //   imgSrc: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-img4-pc.jpg',
        //   titleSrc: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-kv-title4-pc.png',
        //   // link: store.state.lang === 'cn' ? '/film' : '/film' + store.state.lang
        // }
      ],
      commentList: [
        {
          img: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/home-comment-img5.png',
          name: 'Mysmartprice',
          intro: 'vivo VISION+ is designed to provide users with better tools that help them to express and improve the imaging experience.',
          link: 'https://mp.weixin.qq.com/s/FCHJ0e1l2NVO3CuGd_HyTg'
        },
        {
          img: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/home-comment-img6.png',
          name: 'Business Standard',
          intro: 'The VISION+ initiative aims to create a visual content ecosystem for mobile photography enthusiasts. This will include content co-creation, education, and cultural exchanges.',
          link: 'https://mp.weixin.qq.com/s/rph1ScdiOaibWmo-KlKaSQ'
        },
        {
          img: "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-comment-img1.jpg",
          name: "T magazine",
          intro:"vivo understands that no matter how the technologies, tools, and forms of creation evolve, individual observation and reflection of the world are always at the heart of image creation.",
          link: "https://mp.weixin.qq.com/s/LvA8W3kZXZXtmzulc6dYIQ",
        },
        {
          img: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/home/home-comment-img3.jpg',
          name: 'WeLens',
          intro: 'vivo seeks to enliven every form of expression to enrich and diversify the language of creation and fully convey what the artist wants to say. Concern for men themselves is the driving force behind vivo\'s constant pursuit for better image production.',
          link: 'https://mp.weixin.qq.com/s/xz7rfxQfLzfTeX8DXAWgDA'
        },
      ],
      linkList: [
        {
          calssName: "link-box-video",
          children: [
            {
              title: "",
              isIframe: false,
              videoUrl: "https://in-exstatic-vivofs.vivo.com/gdHFRinHEMrj3yPG/in/resource/video/3aefa93f59d0b72d3798440a24096cfd.mp4",
              videoPoster:
                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/video-poster-img1-pc.jpg",
              autoplay: true,
            },
            {
              title: "",
              isIframe: false,
              videoUrl: "https://in-exstatic-vivofs.vivo.com/gdHFRinHEMrj3yPG/in/resource/video/fe3e486aec59235243c1af513ab4127b.mp4",
              videoPoster:
                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/video-poster-img2-pc.jpg",
              autoplay: true,
            },
            {
              title: "",
              isIframe: false,
              videoUrl: "https://in-exstatic-vivofs.vivo.com/gdHFRinHEMrj3yPG/in/resource/video/95f519cbac4a473aa37065c0c165e469.mp4",
              videoPoster:
                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/video-poster-img3-pc.jpg",
              autoplay: true,
            },
          ],
        },
        {
          calssName: "link-box-target",
          children: [
            {
              title: "Create Together",
              videoPoster:
                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/link-img1-pc.jpg",
                link: 'https://www.vivo.com/in/activity/visionplus-create'
            },
            {
              title: "Ways of Seeing 2020",
              videoPoster:
                "https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/nav/in_img/link-img2-pc.jpg",
                link: 'https://www.vivo.com/in/activity/visionplus-ways'
            },
          ],
        },
      ],
      //   detail: "查看详情",
    };
  },
  created() {
    this.commentListShow();
    // if()
  },
  methods: {
    // searchFormWidth() {
    //   let w = window.innerWidth;
    //   if (w <= 768) {
    //     this.arrow = "always";
    //   } else {
    //     this.arrow = "hover";
    //   }
    // },
    commentListShow() {
      if (this.commentList.length > 1) {
        this.arrow = "always";
      } else {
        this.arrow = "never";
      }
    },
    closeVideo(isclose) {
      this.openVideo = isclose;
      document
        .getElementsByTagName("body")[0]
        .classList.remove("el-popup-parent--hidden");
    },
    openVideoEvent(cfg) {
      this.videoConfig = cfg;
      this.openVideo = true;
      document
        .getElementsByTagName("body")[0]
        .classList.add("el-popup-parent--hidden");
    },
    imgEvent (e) {
        this.openVideoEvent(e)
    }
  },
};
</script>
<style lang="scss">
.home {
  .el-icon-arrow-right:before {
    content: "";
    background: url("../assets/svg/right-black.svg") no-repeat;
    background-size: 8px 10px;
    width: 8px;
    height: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media screen and (max-width: 768px) {
      background-size: 6 * 5.12px 8 * 5.12px;
      width: 6 * 5.12px;
      height: 8 * 5.12px;
    }
  }
  .el-icon-arrow-left:before {
    content: "";
    background: url("../assets/svg/left-black.svg") no-repeat;
    background-size: 8px 10px;
    width: 8px;
    height: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media screen and (max-width: 768px) {
      background-size: 6 * 5.12px 8 * 5.12px;
      width: 6 * 5.12px;
      height: 8 * 5.12px;
    }
  }
  .block {
    .banner {
      img {
        object-fit: cover;
      }
    }
  }
  .comment {
    @media screen and (max-width: 768px) {
        box-sizing: border-box;
        padding-top: 60*5.12px;
      }
    .el-carousel {
      width: 100%;
      height: 220px;
      @media screen and (min-width: 1921px) {
        height: 220px;
      }
      @media screen and (max-width: 768px) {
        height: 400*5.12px;
      }
      .el-carousel__indicators {
        display: none;
      }

      .el-carousel__container {
        height: 100%;

        .el-carousel__arrow {
          width: 72px;
          height: 42px;
          border-radius: 21px;
          background: #ffffff;
          @media screen and (min-width: 1921px) {
            width: 72Px;
            height: 42Px;
            border-radius: 21Px;
          }
          @media screen and (max-width: 768px) {
            width: 24*5.12px;
            height: 24*5.12px;
            border-radius: 50%;
          }

          i {
            color: #000000;
          }
        }

        .el-carousel__arrow--left {
          left: 360px;
        }

        .el-carousel__arrow--right {
          right: 360px;
        }
        @media screen and (max-width: 768px) {
          .el-carousel__arrow--left,.el-carousel__arrow--right {
            top: auto;
            transform: translateY(0);
            bottom: 20*5.12px;
          }
          .el-carousel__arrow--left {
            left: 20*5.12px;
          }
          .el-carousel__arrow--right {
            left: 84*5.12px;
            right: auto;
          }
        }

      }
    }
  }
}
</style>
<style scoped lang="scss">
.mb-hide {
  display: block;
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.mb-show {
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }
}

.home {
  overflow: hidden;
  .kv {
    .block {
      .el-carousel__item h3 {
        color: #475669;
        opacity: 0.75;
        line-height: 1000px;
        margin: 0;
        font-size: 100px;
        text-align: center;
      }
      .kv-title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }
      .banner1 {
        .kv-title {
          width: 414px;
          height: 108px;
          margin-left: -430px;
          @media screen and (max-width: 768px) {
            width: 335 * 5.12px;
            height: 88 * 5.12px;
            margin-left: 0;
          }
        }
      }
    }
  }
  .comment {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    z-index: 10;
    background-color: #edeff2;
    // backdrop-filter: saturate(180%) blur(20PX);
    @media screen and (max-width: 768px) {
      // display: none;
    }

    .title {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      font-size: 20px;
      font-family: "font-HYQH-55S";
      width: 740px;
      top: 30px;
      @media screen and (max-width: 768px) {
        width: 335*5.12px;
        top: auto;
        font-size: 20*5.12px;
        line-height: 1;
        left: 20*5.12px;
        transform: translateX(0);
        margin-bottom: 40*5.12px;
      }
    }

    .comment-box {
      position: relative;
      margin: 0 auto;
      width: 740px;
      height: 100%;
      display: flex;
      align-items: center;
      @media screen and (max-width: 768px) {
        width: 335*5.12px;
        margin-left: 20*5.12px;
        display: block;
      }
      .comment-img {
        @media screen and (max-width: 768px) {
          margin-bottom: 20*5.12px;
        }
        .img {
          width: 80px;
          height: 80px;
          @media screen and (max-width: 768px) {
            width: 64*5.12px;
            height: 64*5.12px;
          }
          img {
            width: 100%;
            height: auto;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .comment-intro {
        margin-left: 40px;
        font-family: "font-HYQH-55S";
        @media screen and (max-width: 768px) {
          margin-left: 0;
        }
        .name {
          font-size: 24px;
          @media screen and (max-width: 768px) {
            font-size: 18*5.12px;
          }
        }

        .intro {
          font-size: 16px;
          color: #666666;
          margin-top: 10px;
          line-height: 1.5;
          @media screen and (max-width: 768px) {
            margin-top: 10*5.12px;
            font-size: 16*5.12px;
          }
        }
      }
    }
  }

  .link-block {
    width: 1440px;
    margin: 0 auto;
    margin-top: 160px;
    margin-bottom: 120px;
    display: flex;
    justify-content: space-between;
    .link-box-video {
      width: 720px;
      ul {
        li {
          width: 100%;
          height: 360px;
        }
        li:nth-child(2) {
          margin: 40px 0;
        }
      }
    }
    .link-box-video,
    .link-box-target {
      ul {
        li {
          width: 100%;
          overflow: hidden;
          border-radius: 24px;
          position: relative;
          &:hover {
            .img-box {
              img {
                transform: scale(1.1);
              }
              .mask {
                opacity: .4;
              }
            }
          }
          .img-box {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
              transition: transform 0.3s ease;
              transform: scale(1);
              
            }
            .mask {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
              background-color: #000;
              transition: opacity .3s ease;
              z-index: 1;
              pointer-events: none;
            }
          }
          .title {
            position: absolute;
            bottom: 60px;
            left: 60px;
            font-size: 16px;
            line-height: 1.5;
            color: #fff;
            font-family: "font-HYQH-65S";
            cursor: pointer;
            z-index: 1;
            img {
              width: 8px;
              height: 12px;
              margin-left: 8px;
              vertical-align: middle;
            }
          }
        }
      }
    }
    .link-box-video {
      ul {
        li {
          .title {
            bottom: 80px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .link-box-target {
      width: 680px;
      ul {
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        li {
          height: 680px;
          .title {
            span {
              font-size: 28px;
            }
             p {
               margin-top: 60px;
               span {
                font-size: 16px;
               }
             }
          }
          
        }
        li:last-child {
          height: 440px;
        }
      }
    }
  }
  .logo-box {
      width: 600px;
      height: 98px;
      margin: 0 auto;
      margin-bottom: 180px;
    //   background-color: red;
      display: flex;
      justify-content: space-between;
      .content {
          display: flex;
          align-items: center;
          div {
              margin-right: 30px;
              font-family: 'font-HYQH-55S';
              font-size: 12px;
              color: #8A8F99;
              white-space: nowrap;
          }
      }
      img { 
          width: 126px;
          height: 98px;
          margin: auto 0;
      }
      .img-left {
          width: 126px;
          height: 100%;
      }
  }
}

@media screen and (min-width: 1921px) {
  .home {
    .kv {
      .block {
        .el-carousel__item h3 {
          color: #475669;
          opacity: 0.75;
          line-height: 1000px;
          margin: 0;
          font-size: 100px;
        }
        .banner1 {
          .kv-title {
            width: 460Px;
            height: 120Px;
            margin-left: -430Px;
          }
        }
      }
    }
    .comment {
      .title {
        font-size: 20Px;
        width: 740Px;
        top: 30Px;
      }

      .comment-box {
        // margin: 0 auto;
        width: 740Px;
        .comment-img {
          .img {
            width: 80Px;
            height: 80Px;
          }
        }

        .comment-intro {
          margin-left: 40Px;

          .name {
            font-size: 24Px;
          }

          .intro {
            font-size: 16Px;
            margin-top: 10Px;
          }
        }
      }
    }
    .link-block {
      width: 1440Px;
      margin-top: 160px;
      margin-bottom: 120Px;
      .link-box-video {
        width: 720Px;
        ul {
          li {
            height: 360Px;
          }
          li:nth-child(2) {
            margin: 40Px 0;
          }
        }
      }
      .link-box-video,
      .link-box-target {
        ul {
          li {
            border-radius: 24Px;
            .title {
              bottom: 60Px;
              left: 60Px;
              font-size: 16Px;
              img {
                width: 8Px;
                height: 12Px;
                margin-left: 8Px;
              }
            }
          }
        }
      }
      .link-box-video {
        ul {
          li {
            .title {
              bottom: 80Px;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }
      .link-box-target {
        width: 680Px;
        ul {
          li {
            height: 680Px;
            .title {
              span {
                font-size: 28Px;
              }
              p {
                margin-top: 60Px;
                span {
                  font-size: 16Px;
                }
              }
            }
          }
          li:last-child {
            height: 440Px;
          }
        }
      }
    }
    .logo-box {
      width: 600Px;
      height: 98Px;
      margin-bottom: 180Px;
      .content {
          div {
              margin-right: 30Px;
              font-size: 12Px;
          }
      }
      img { 
          width: 126Px;
          height: 98Px;
      }
      .img-left {
          width: 126Px;
      }
  }
  }
}
@media screen and (max-width: 768px) {
    .home {
        .link-block {
            width: 335 * 5.12px;
            margin-top: 80 * 5.12px;
            margin-bottom: 80 * 5.12px;
            flex-wrap: wrap;
            .link-box-video,
            .link-box-target{
                width: 100%;
                ul {
                    li {
                        height: 200 * 5.12px;
                        border-radius: 12*5.12px;
                        .title {
                          bottom: 31*5.12px;
                          left: 30*5.12px;
                          font-size: 12*5.12px;
                          line-height: 1.5;
                          img {
                            width: 6*5.12px;
                            height: 9*5.12px;
                            margin-left: 8px;
                            vertical-align: middle;
                          }
                        }
                    }
                }
                
            }
            .link-box-video {
                ul {
                    li:nth-child(2) {
                        margin: 20 * 5.12px 0;
                    }
                    li {
                      .title {
                        bottom: 38 * 5.12px;
                        left: 50%;
                        transform: translateX(-50%);
                        font-size: 12 * 5.12px;
                      }
                    }
                }
            }
            .link-box-target {
                ul {
                    li {
                        margin-top: 20 * 5.12px;
                        .title {
                          span {
                            font-size: 20*5.12px;
                            line-height: 1;
                          }
                          p {
                            margin-top: 20*5.12px;
                            span {
                              font-size: 12*5.12px;
                            }
                          }
                        }
                    }
                    li:last-child {
                        height: 200 * 5.12px;
                    }
                }
            }
        }
        .logo-box {
            width: 335 * 5.12px;
            height: auto;
            margin-bottom: 120 * 5.12px;
            margin-top: 80 * 5.12px;
            flex-direction: column;
            align-items: center;
            .content {
                display: flex;
                align-items: center;
                flex-direction: column;
                margin-bottom: 50 * 5.12px;
                &:last-child {
                    margin-bottom: 0;
                }
                div {
                    margin-right: 0 * 5.12px;
                    font-size: 12 * 5.12px;
                }
            }
            img { 
                width: 48 * 5.12px;
                height: 48 * 5.12px;
                margin-top: 20 * 5.12px;
            }
            .img-left {
                width: 90 * 5.12px;
                height: 70 * 5.12px;
                margin-top: 10 * 5.12px;
            }
        }
    }
  
}
</style>
